export const SET_SCHEDULER_CREW_DATA = 'SET_SCHEDULER_CREW_DATA';
export const UPDATE_SCHEDULER_CREW = 'UPDATE_SCHEDULER_CREW';
export const UPDATE_SCHEDULER_CREW_DATE = 'UPDATE_SCHEDULER_CREW_DATE';
export const SET_SCHEDULER_JOB_DATA = 'SET_SCHEDULER_JOB_DATA';
export const ADD_NEW_ORDER = 'ADD_NEW_ORDER';
export const DELETE_PLACEHOLDER_ORDER = 'DELETE_PLACEHOLDER_ORDER';
export const SET_SCHEDULER_JOB_CREW_DATA = 'SET_SCHEDULER_JOB_CREW_DATA';
export const SET_IS_INFORM_CHANGE_DATES = 'SET_IS_INFORM_CHANGE_DATES';